import useBranding from "../branding/useBranding";

const ADBrand: { [key: string]: string } = {
  default: "",
  skyresponse: "",
  hepro: "?brand=hepro",
  careium: "?brand=careium",
  zafe: "?brand=zafe",
  viser: "?brand=viser",
  telealarm: "?brand=telealarm",
  chubb: "?brand=chubb",
  curena: "?brand=curena",
};

export const useADLoginLink = () => {
  const brandingData = useBranding();
  const getADLoginLink = () => {
    if (process.env.REACT_APP_ENVIRONMENT === "dev") {
      return `https://login.dev.skyresponse.com/`;
    }
    if (process.env.REACT_APP_ENVIRONMENT === "stage") {
      return `https://sso-stage.skyresponse.com/`;
    }
    return "https://login.skyresponse.com";
  };
  return getADLoginLink() + ADBrand[brandingData.customerKey];
};

export const useADLogoutLink = () => {
  if (process.env.REACT_APP_ENVIRONMENT === "dev") {
    return `https://login.dev.skyresponse.com/logout`;
  }
  if (process.env.REACT_APP_ENVIRONMENT === "stage") {
    return `https://sso-stage.skyresponse.com/logout`;
  }
  return "https://login.skyresponse.com/logout";
};
